export default __webpack_public_path__ + "static/media/promo-undesirable-no-1_03.66dc8e14.jpg";